import { axiosClient } from "../api-client";

export function Shipment({ config, body }) {
	return axiosClient.post("/v1/shipping/shipment", body, config);
}

export function GetAddress({ config, body }) {
	return axiosClient.get("/v1/shipping/address/" + body, config);
}

export function ShipController({ config, body }) {
	return axiosClient.patch("/v1/shipping/redeem/status", body, config);
}

export function ShipHistory({ config, body }) {
	return axiosClient.get("/v1/shipping/redeem/history/" + body, config);
}

export function ShipAccountGet({ config }) {
	return axiosClient.get("/v1/shipping/ups/list", config);
}

export function ShipAccountDelete({ config, body }) {
	return axiosClient.delete("/v1/shipping/ups/" + body, config);
}

export function ShipAccountCreate({ config, body }) {
	return axiosClient.post("/v1/shipping/ups/create", body, config);
}

export function ShipLabel({ config, body }) {
	return axiosClient.get("/v1/shipping/label/" + body + "/detail", config);
}
